import styled from 'styled-components';
import { Form as FormContainer } from '@unform/web';

import { SeparateLabel } from '../../../../components/SeparateLabel';
import { ButtonConfirm } from '../../../../components/ButtonConfirm';
import { TextInfo } from '../../../../components/TextInfo';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const PageTitle = styled.h1`
  font-size: 40px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.02em;
  margin-bottom: 24px;
`;

export const Form = styled(FormContainer)`
  display: flex;
  flex-direction: column;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 24px;
  align-items: start;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  position: relative;

  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.lg};
  padding: 28px;
  margin-bottom: 24px;

  & > * {
    margin-bottom: 16px;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

// Cobrança e Ficha de treino têm várias linhas de campos lado a lado
// (Row2/Row4) -- confinadas na coluna de 2fr (junto com Informações
// gerais/Detalhes adicionais) elas ficam apertadas à toa, já que a
// coluna de 1fr ao lado só tem a logo e o horário. `grid-column: 1/-1`
// as tira do fluxo de coluna e estica pra largura inteira do Grid.
export const FullWidthCard = styled(Card)`
  grid-column: 1 / -1;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  p {
    font-size: 13px;
    color: ${colors.onSurfaceVariant};
  }
`;

export const Row2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const Row4 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr 1fr;
  }
`;

// Só usado pelos campos de Ficha de treino, agora que o card ocupa a
// largura inteira (ver FullWidthCard) -- as 5 colunas cabem numa linha
// só em vez das 3 linhas de antes (2x Row2 + 1 campo solto).
export const Row5 = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ScheduleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  span {
    font-size: 13px;
    color: ${colors.onSurface};
    flex-shrink: 0;
    width: 80px;
  }

  div {
    max-width: 96px;
  }
`;

export const Info = styled(TextInfo)`
  margin: 10px 0;
`;

export const Separate = styled(SeparateLabel)``;

export const Confirm = styled(ButtonConfirm)`
  align-self: center;
  margin: 16px 0;
`;

export const Field = styled.div`
  label {
    display: block;
    margin-bottom: 8px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.onSurfaceVariant};
  }

  p {
    margin-top: 8px;
    font-size: 12px;
    color: ${colors.onSurfaceVariant};
  }
`;

export const FieldInput = styled.input`
  width: 100%;
  padding: 14px 16px;
  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.outlineVariant};
  background-color: ${colors.surface};
  color: ${colors.onSurface};
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${colors.primary};
  }

  &:disabled {
    opacity: 0.6;
  }

  /* Remove as setas do input numérico (Chrome/Safari/Edge e Firefox). */
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const ToggleTrack = styled.button<{ isChecked: boolean }>`
  flex-shrink: 0;
  width: 44px;
  height: 26px;
  border-radius: ${radius.full};
  border: none;
  cursor: pointer;
  position: relative;
  transition: background-color 0.15s ease;

  background-color: ${props =>
    props.isChecked ? colors.primary : colors.outlineVariant};

  &::after {
    content: '';
    position: absolute;
    top: 3px;
    left: ${props => (props.isChecked ? '21px' : '3px')};
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${colors.surface};
    transition: left 0.15s ease;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
